module.exports = "<select class=\"form-control\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-change=\"$ctrl._ngChange()\"\n        ng-attr-data-testid=\"{{$ctrl.testId}}\"\n        ng-options=\"item.id as item.name for item in $ctrl.$user.companies\">\n    <option value=\"\">Select Company</option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/company-id.picker.html
// module id = 595
// module chunks = 0